<template>
  <section class="invoice-preview-wrapper">
    <DeleteModal
      class="display-none-print"
      modalId="modal-delete"
      @deleteToggle="deleteItem"
    />
    <DeleteModal
      class="display-none-print"
      modalId="radiology-delete"
      @deleteToggle="deleteRadiologyItem"
    />

    <b-modal
      id="modal-create-radiology"
      ok-only
      centered
      size="lg"
      no-close-on-backdrop
      :title="`${$t('radiology.creat-radiology')}`"
    >
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="createRadiology"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.submit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
      <b-row>
        <b-col md="12" cols="12">
          <AutoComplete
            v-model="createRadiologyForm.radiology_id"
            :label="$t('radiology.radiology')"
            :placeholder="$t('radiology.radiology')"
            param-query="name"
            :serializer="(val) => val.id"
            endpoint="radiology"
            text-title="name"
            keyword="patient"
          />
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-upload-attachment" title="Upload Attachment" ok-only>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitAttachment"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.submit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
      <b-form-file
        v-model="selectedFile"
        accept=".jpg,.jpeg,.png,.pdf"
        @change="previewFile"
      ></b-form-file>
      <div v-if="filePreview">
        <img
          v-if="isImage"
          :src="filePreview"
          alt="Image Preview"
          width="100%"
        />
        <embed
          v-else
          :src="filePreview"
          type="application/pdf"
          width="100%"
          height="400px"
        />
      </div>
    </b-modal>

    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <h2>{{ $t("radiology.patient-info") }}</h2>
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
        </b-row>
        <b-row>
          <!-- <b-col
            style="cursor: pointer"
            @click="$router.go(-1)"
            md="12"
            cols="12"
          >
            <statistic-card-horizontal
              icon=""
              :statistic="$t('common.go-back')"
              class="modify"
            />
          </b-col> -->
          <b-col cols="12" sm="12">
            <!-- Patient Info -->
            <b-card>
              <!-- <h2
                class="text-center"
                style="font-weight: bold; text-transform: capitalize"
              >
                patient info
              </h2> -->
              <hr />
              <div>
                <h5 class="my-2">
                  <b>{{ $t("common.name") }}:</b>
                  <p class="mx-2 d-inline d-inline">
                    {{ getNestedProperty(patientCardsData, "patient.name") }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.companion-name") }}:</b>
                  <p class="mx-2 d-inline d-inline">
                    {{ patientCardsData.full_companion_name }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.companion-phone") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ patientCardsData.companion_phone }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.next-kin-name") }}:</b>
                  <p class="mx-2 d-inline d-inline">
                    {{ patientCardsData.next_of_kin_name }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.next-kin-phone") }}:</b>
                  <p class="mx-2 d-inline d-inline">
                    {{ patientCardsData.next_of_kin_phone_number }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.card-type") }}:</b>
                  <p class="mx-2 d-inline">{{ patientCardsData.type }}</p>
                </h5>
                <h5 class="my-2">
                  <b class="text-danger">{{ $t("reception.allergy") }}:</b>
                  <p class="mx-2 d-inline text-danger">
                    {{ patientCardsData.allergy }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.smoking") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ !patientCardsData.is_smoker ? "No" : "Yes" }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.diabetic") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ !patientCardsData.has_diabetes ? "No" : "Yes" }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.heart-disease") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ !patientCardsData.has_heart_disease ? "No" : "Yes" }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.hypertension") }}:</b>
                  <p class="mx-2 d-inline">
                    {{
                      !patientCardsData.has_high_blood_pressure ? "No" : "Yes"
                    }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.weight") }}:</b>
                  <p class="mx-2 d-inline">{{ patientCardsData.weight }}</p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.height") }}:</b>
                  <p class="mx-2 d-inline">{{ patientCardsData.height }}</p>
                </h5>

                <h5 class="my-2">
                  <b>{{ $t("reception.room") }}:</b>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.patient-case") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ patientCardsData.patient_case }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.diagnosis") }}:</b>
                  <p class="mx-2 d-inline">{{ patientCardsData.diagnosis }}</p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.investigation") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ patientCardsData.investigation }}
                  </p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.treatment") }}:</b>
                  <p class="mx-2 d-inline">{{ patientCardsData.treatment }}</p>
                </h5>
                <h5 class="my-2">
                  <b>{{ $t("reception.examination") }}:</b>
                  <p class="mx-2 d-inline">
                    {{ patientCardsData.examination }}
                  </p>
                </h5>
                <!-- <h5 class="my-2">
                <b>{{ $t('reception.patient-case-detalis') }}:</b>
                <p class="mx-2 d-inline">
                  {{ patientCardsData.patient_case_details }}
                </p>
              </h5> -->
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <h2 style="display: inline">
          {{ $t("radiology.create-patient-radiology-attachments") }}
        </h2>
        <b-button
          variant="primary"
          class="ml-2"
          @click="openModalCreateRadiology()"
        >
          {{ $t("radiology.creat-radiology") }}
        </b-button>
      </div>
      <hr />
      <div v-if="radiologyPatientData.length > 0" class="grid-container">
        <div
          style="
            border: 2px solid black;
            border-radius: 10px;
            margin: 5px;
            padding: 0px;
            width: 450px;
          "
          v-for="radiology in radiologyPatientData"
          :key="radiology.id"
        >
          <div>
            <div class="d-flex justify-content-between" style="margin: 10px">
              <h3 class="text-center mt-1" style="font-weight: bolder">
                {{ getRadiologyName(radiology.radiology_id) }}
              </h3>
              <b-button
                variant="success"
                @click="openUploadModal(radiology)"
                style="margin-top: 10px"
                size="sm"
              >
                add attachment
              </b-button>
              <b-button
                variant="danger"
                @click="deleteRadiology(radiology)"
                style="margin-top: 10px"
                size="sm"
              >
                {{ $t('common.delete') }}
              </b-button>
            </div>
            <hr />
            <div
              v-for="attachment in radiology.attachments"
              :key="attachment.id"
              class="m-1 text-center"
            >
              <div v-if="!attachment.attachment_url.includes('pdf')">
                <img
                  width="350"
                  height="200"
                  :src="attachment.attachment_url"
                  alt="attachment"
                  style="border-radius: 10px"
                />
                <br />
                <div class="">
                  <b-button
                    variant="danger"
                    @click="deleteModel(attachment)"
                    class="mx-2 my-1"
                  >
                    {{ $t("common.delete") }}
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="openPdf(attachment.attachment_url)"
                    class="mx-2 my-1"
                  >
                    {{ $t("common.show") }}
                  </b-button>
                </div>
                <hr />
              </div>

              <div v-else>
                <embed
                  :src="attachment.attachment_url"
                  type="application/pdf"
                  width="100%"
                  height="250px"
                  style="border-radius: 10px"
                />

                <b-button
                  variant="danger"
                  @click="deleteRadiology(attachment)"
                  class="delete-btn mx-2 my-1"
                >
                  {{ $t("common.delete") }}
                </b-button>
                <b-button
                  variant="primary"
                  @click="openPdf(attachment.attachment_url)"
                  class="review-btn mx-2 my-1"
                >
                  {{ $t("common.show") }}
                </b-button>

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center" style="height: 200px;">
        <div class="d-flex justify-content-center align-items-center">
          <p
            style="
              font-size: 20px;
              font-weight: bold;
              margin-top: 90px;
              color: #959595;
              text-align: center;
              border: 4px dashed #959595;
              border-radius: 10px;
              padding: 10px;
              margin-top: 10px;
            "
          >
            {{ $t("radiology.no-radiology") }}
          </p>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIconSearch,
  BModal,
  BIcon,
  BIconFileEarmarkPdf,
  BFormFile,
} from "bootstrap-vue";
import axios from "axios";
import vSelect from "vue-select";
import PatientSearch from "@/components/patientSearch.vue";
import formatPhoneNumber from "@/utils/formatPhoneNumber";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BIconSearch,
    PatientSearch,
    AutoComplete,
    ToastificationContent,
    BIcon,
    BIconFileEarmarkPdf,
    DeleteModal,
    BFormFile,
  },
  data() {
    return {
      patientCardsData: [],

      page: 1,
      totalRows: "",
      todayDate: "",
      take: 10,
      loading: false,
      selected: "",
      option: [],
      cardId: "",
      createRadiologyForm: {
        patient_card_id: this.$route.params.cardId,
        type: "0",
        // attachment: "",
        radiology_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      radiologyPatientData: [],
      radiologyData: [],
      deleteForm: {},
      selectedFile: null,
      filePreview: null,
      isImage: false,
      attachmentForm: {},
    };
  },

  mounted() {
    this.cardId = this.$route.params.cardId;
    console.log(this.cardId);
    this.getPatientCards();
    this.getPatientRadiology();
    this.getRadiology();
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      return result;
    },
    openModalCreateRadiology() {
      this.$bvModal.show("modal-create-radiology");
    },
    // this is trmporary
    formatPhoneNumber,
    async getPatientCards() {
      this.loading = true;
      let url = `/patientCard?include=patient&page=${this.page}&take=${this.take}&sort=-id&filter[is_active]=true&filter[id]=${this.cardId}`;

      if (this.patientName) {
        console.log(this.patientName);
        url += `&filter[patient.name]=${this.patientName}`;
      }

      await this.getList(url);
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.dataCount = this.all_data.total;
      this.patientCardsData = this.all_data.data[0];
      console.log(this.patientCardsData);
      this.loading = false;
    },
    async getPatientRadiology() {
      await this.getList(
        `patientCardRadiology?take=20&filter[patient_card_id]=${this.cardId}&include=attachments`
      );
      this.radiologyPatientData = this.all_data.data;
      console.log(this.radiologyPatientData);
    },
    async createRadiology() {
      console.log(this.createRadiologyForm);
      this.loading = true;

      (this.params.form = this.createRadiologyForm),
        (this.params.path = `/patientCardRadiology`),
        this.$store
          .dispatch("create", this.params)
          .then(async (response) => {
            await this.getPatientRadiology();
            this.$bvModal.hide("modal-create-radiology");
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "success",
                variant: "success",
                text: "Radiology created successfully",
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    async getRadiology() {
      await this.getList(`radiology`);
      this.radiologyData = this.all_data.data;
      console.log(this.radiologyData);
    },
    getRadiologyName(radiologyId) {
      for (let radiology of this.radiologyData) {
        if (radiology.id === radiologyId) {
          //   console.log(radiology.name);
          return radiology.name;
        }
      }
      return "N/A";
    },
    openPdf(url) {
      window.open(url, "_blank");
    },
    deleteModel(item) {
      this.deleteForm = item;
      console.log("deleteForm", this.deleteForm);
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/attachment/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientRadiology();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text:
                "deleted " + this.deleteForm.attachment_url + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.attachment_url,
            },
          });
        });
    },
    deleteRadiology(radiology) {
      this.deleteForm = radiology;
      console.log("deleteRadiology", this.deleteForm);
      this.$bvModal.show("radiology-delete");
    },
    deleteRadiologyItem() {
      this.$store
        .dispatch("delete", `/patientCardRadiology/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientRadiology();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted radiology successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting radiology",
            },
          });
        });
    },
    openUploadModal(radiology) {
      this.attachmentForm.attachable_id = radiology.id;
      this.attachmentForm.attachable_type = "radiology";
      this.$bvModal.show("modal-upload-attachment");
    },
    previewFile(event) {
      const file = event.target.files[0];
      if (file) {
        this.isImage = file.type.startsWith("image/");
        const reader = new FileReader();
        reader.onload = (e) => {
          this.filePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    async submitAttachment() {
      this.loading = true;
      if (!this.selectedFile) return;

      const formData = new FormData();
      formData.append("attachment", this.selectedFile);
      formData.append("attachable_id", this.attachmentForm.attachable_id);
      formData.append("attachable_type", this.attachmentForm.attachable_type);

      try {
        const response = await axios.post("/attachment", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("File uploaded successfully", response.data);
        this.$bvModal.hide("modal-upload-attachment");
        this.selectedFile = null;
        this.filePreview = null;
        this.loading = false;
        this.getPatientRadiology();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Upload Success",
            icon: "success",
            variant: "info",
            text: "File uploaded successfully",
          },
        });
      } catch (error) {
        console.error("Error uploading file", error);
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Upload Error",
            icon: "error",
            variant: "danger",
            text: "Error uploading file",
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  /* padding: 20px; */
  border: 4px dashed #959595;
  border-radius: 10px;
  padding: 10px;
  justify-items: center;
  margin-top: 10px;
}

.review-btn {
  margin-right: 80px; /* Add gap between delete-btn and review-btn */
}

.delete-btn {
  margin-left: 80px; /* Add gap between delete-btn and review-btn */
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 120px;
  width: 100%;
  position: relative;
  top: -190px;
}

.action-buttons b-button {
  flex: 1;
  margin: 5px;
}

.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
